const debounce = (fn, delay) => {
  var timer = null;
  return function () {
    let args = arguments;
    timer && clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, [...args]);
    }, delay)
  }
}

const throttle = (fn, delay) => {
  var timer = null;
  return function () {
    let args = arguments;
    if (timer) return;
    timer = setTimeout(() => {
      fn.apply(this, [...args]);
      timer = null;
    }, delay)
  }
}

export { debounce, throttle };